'use client'

import type { ReactNode } from 'react'

import { StarIcon } from '@/components/icons/svg/agent'
import { cn } from '@/lib/utils/cn'

interface GenerateVoiceButtonProps {
  children: ReactNode
  className?: string
  disabled?: boolean
  loading?: boolean
  loadingContent?: ReactNode
  onClick?: () => void
}

export const GenerateVoiceButton = ({
  children,
  className,
  disabled,
  loading,
  loadingContent,
  onClick,
}: GenerateVoiceButtonProps) => (
  <button
    disabled={disabled || loading}
    type="button"
    className={cn(
      'inline-flex w-full items-center justify-center gap-2 rounded-[10px] border border-white px-[22px] py-[11px] text-[13px] font-semibold [font-family:inherit] sm:w-auto',
      disabled || loading
        ? 'cursor-not-allowed bg-white/[0.08] text-[var(--text-1)] opacity-50'
        : 'cursor-pointer bg-white text-[#1a1a1a]',
      className
    )}
    onClick={onClick}
  >
    {loading ? (
      (loadingContent ?? (
        <span
          aria-hidden
          className="inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      ))
    ) : (
      <>
        <StarIcon className="size-4 shrink-0" />
        {children}
      </>
    )}
  </button>
)
